import { BUYER_SUPPORTED_PHONE_NUMBERS, SUPPORTED_COUNTRIES } from '@application/constants';
import { useValidation } from '@application/utils';
import { useMemo } from 'react';
import { bool, object, string } from 'yup';

export const useValidationSchema = () => {
  const { requiredMessage, invalidMessage, emailMessage, isValidMobilePhone } = useValidation();

  const validationSchema = useMemo(() => {
    return object({
      firstName: string().required(requiredMessage),
      lastName: string().required(requiredMessage),
      email: string().email(emailMessage).required(requiredMessage),
      message: string().required(requiredMessage),
      phonePrefixCountry: string().oneOf(BUYER_SUPPORTED_PHONE_NUMBERS).required(requiredMessage),
      phone: string()
        .test('is-valid', invalidMessage, (value: any, context) => {
          if (value === null) {
            return true;
          }
          if (context.parent.phonePrefixCountry === 'EU') {
            return !!value;
          }
          if (SUPPORTED_COUNTRIES.includes(context.parent.phonePrefixCountry)) {
            if (context.parent.phonePrefixCountry === 'DE') {
              return (
                value?.match(/^0?((\+?)([0-9]){10})$/) || value?.match(/^0?((\+?)([0-9]){11})$/)
              );
            }
            return value?.match(/^0?((\+?)([0-9]){9})$/);
          }

          return isValidMobilePhone(value as string);
        })
        .required(requiredMessage),
      marketingEmailConsent: bool().oneOf([true], requiredMessage),
    });
  }, [emailMessage, invalidMessage, isValidMobilePhone, requiredMessage]);

  return { validationSchema };
};
